import { clstx } from '@payaca/utilities/cvaMerge';
import { motion } from 'motion/react';
import { ComponentPropsWithoutRef, forwardRef } from 'react';
import UntitledLoading from '../UntitledLoading/UntitledLoading';
import useButtonClassName, { ButtonVariantProps } from './useButtonClassName';

export interface ButtonProps
  extends ComponentPropsWithoutRef<'button'>, ButtonVariantProps {
  isProcessing?: boolean;
  replaceContentWhenProcessing?: boolean;
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const {
    className,
    type = 'button',
    variant,
    size,
    colour,
    linkColour,
    children,
    shape,
    isProcessing = false,
    replaceContentWhenProcessing = false,
    ...rest
  } = props;

  const variantClassName = useButtonClassName({
    variant,
    size,
    colour,
    linkColour,
    shape,
  });

  return (
    <button
      ref={ref}
      type={type}
      className={clstx(variantClassName, 'relative', className)}
      {...rest}
    >
      {!(replaceContentWhenProcessing && isProcessing) && children}
      {isProcessing && <UntitledLoading className="h-4 w-4" />}
    </button>
  );
});

export default Object.assign(Button, {
  motion: motion.create(Button),
});
